<template>
  <div>
    <div class="ch-head">
      <div>
        <h1>购买积分</h1>
        <p>充值按官方原价，1 元 = 10 积分，不打折。折扣以返利代金券发放，只能在本页兑换进积分池。积分可划给已同意绑定的会员，会员用这笔积分创作。</p>
      </div>
    </div>
    <div class="ch-metrics three">
      <div class="ch-metric"><div class="k">积分池</div><div class="v">{{ desk.points || 0 }}</div><div class="s">可划拨余额</div></div>
      <div class="ch-metric"><div class="k">已绑定会员</div><div class="v">{{ desk.memberCount || 0 }}</div><div class="s">到「名下会员」查看和划拨</div></div>
      <div class="ch-metric"><div class="k">返利比例</div><div class="v" style="font-size:18px">{{ rebateText }}</div><div class="s">未配置时只入积分、不发券</div></div>
    </div>
    <div class="ch-grid2">
      <div class="ch-panel">
        <h2>充值积分</h2>
        <div class="ch-filters">
          <label>金额（元）<input v-model="yuan" placeholder="最低 1 元，例如 1000" /></label>
        </div>
        <div class="ch-filters">
          <button class="ch-btn" :class="{ gold: channel === 'wechat' }" type="button" @click="channel = 'wechat'">微信支付</button>
          <button class="ch-btn" :class="{ gold: channel === 'alipay' }" type="button" @click="channel = 'alipay'">支付宝</button>
          <button class="ch-btn" :class="{ gold: channel === 'bank' }" type="button" @click="channel = 'bank'">对公转账</button>
        </div>
        <button class="ch-btn gold" type="button" style="margin-top:12px" :disabled="submitting" @click="openPay">{{ channel === 'bank' ? '对公转账' : '去支付' }}</button>
        <p class="ch-note">最低充值 1 元。</p>
        <table class="ch-table" style="margin-top:16px">
          <thead><tr><th>创建时间</th><th>金额</th><th>积分</th><th>方式</th><th>状态</th></tr></thead>
          <tbody>
            <tr v-for="row in shownRecharges" :key="row.id">
              <td>{{ timeText(row.createdAt) }}</td>
              <td>¥ {{ row.yuanAmount }}</td>
              <td>{{ row.points }}</td>
              <td>{{ channelText(row.payChannel) }}</td>
              <td>
                <button v-if="row.status === 'PAYING'" class="ch-link" type="button" @click="continuePay(row)">待支付</button>
                <span v-else>{{ rechargeStatus(row.status) }}</span>
              </td>
            </tr>
            <tr v-if="!recharges.length"><td colspan="5" class="ch-empty">还没有充值</td></tr>
          </tbody>
        </table>
        <div v-if="pageCount > 1" class="pager">
          <button type="button" :disabled="page <= 1" @click="page = page - 1">上一页</button>
          <span>{{ page }} / {{ pageCount }}</span>
          <button type="button" :disabled="page >= pageCount" @click="page = page + 1">下一页</button>
        </div>
      </div>
      <div class="ch-panel">
        <h2>兑换返利券</h2>
        <p class="ch-note">指定入口只在这里。按券面原价兑换，20 元面值到账 200 积分。会员端的兑换码入口不能用这张券。</p>
        <div class="ch-filters">
          <label>兑换码<input v-model="code" /></label>
        </div>
        <button class="ch-btn" type="button" @click="redeem">兑换进积分池</button>
        <h2 style="margin-top:22px">推广链接</h2>
        <p class="ch-note">把链接或二维码发出去。新用户注册时必须勾选，才绑定到你，并同意作品与你共享。</p>
        <p v-if="link" style="word-break:break-all">{{ link }}</p>
        <p v-else class="ch-note">门户地址还没配置，暂时不能生成注册链接。</p>
        <button v-if="link" class="ch-btn" type="button" @click="copy">复制链接</button>
      </div>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="payOpen" width="460px" append-to-body @close="onPayClose">
      <div v-if="channel === 'bank'" class="pay-box">
        <p class="pay-tip">按下面账户打款，上传凭证后提交。总部审核到账后积分进入池子。</p>
        <div class="bank-line"><span>公司名称</span><b>{{ bank.companyName }}</b></div>
        <div class="bank-line"><span>统一信用代码</span><b>{{ bank.creditCode }}</b></div>
        <div class="bank-line"><span>地址</span><b>{{ bank.address }}</b></div>
        <div class="bank-line"><span>开户行</span><b>{{ bank.bankName }}</b></div>
        <div class="bank-line"><span>银行账号</span><b>{{ bank.accountNo }}</b></div>
        <button class="ch-btn" type="button" @click="copyBank">复制账户信息</button>
        <div class="proof">
          <label>转账凭证
            <input type="file" accept="image/*,.pdf" @change="onProof" />
          </label>
          <span v-if="proofName">{{ proofName }}</span>
        </div>
      </div>
      <div v-else class="pay-box pay-qr">
        <p class="pay-tip">应付 ¥ {{ payAmount }}。支付成功后积分自动进入池子，本窗口会关闭。</p>
        <img v-if="qrImage" :src="qrImage" alt="支付二维码" width="200" height="200" />
        <p v-if="channel !== 'alipay' && paySession && paySession.payUrl && !qrImage"><a :href="paySession.payUrl" target="_blank" rel="noopener">打开支付页面</a></p>
      </div>
      <span slot="footer">
        <button v-if="channel === 'bank'" class="ch-btn gold" type="button" :disabled="submitting" @click="recharge">提交审核</button>
        <button class="ch-btn" type="button" @click="payOpen = false">关闭</button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from 'qrcode'
import { getEcoDesk, createEcoRecharge, refreshEcoRecharge, resumeEcoRecharge, redeemEcoRebate } from '@/api/admin'
import { uploadFile } from '@/api/upload'
import { normalizeFileUrl } from '@/utils/fileUrl'

const BANK = {
  companyName: '星河逐梦（福建）科技有限公司',
  creditCode: '91350104MAKHQW4K74',
  address: '福建省福州市仓山区上渡街道上渡路379号二楼2700号办公用房',
  bankName: '招商银行鼓楼支行',
  accountNo: '591911717810001'
}

export default {
  name: 'PartnerEco',
  data() {
    return {
      desk: {}, yuan: '', code: '', page: 1,
      channel: 'wechat', proofUrl: '', proofName: '',
      payOpen: false, paySession: null, qrImage: '', submitting: false, pollTimer: null
    }
  },
  computed: {
    recharges() { return (this.desk.recharges || []).filter(row => row.status !== 'CANCELLED') },
    pageCount() { return Math.max(1, Math.ceil(this.recharges.length / 8)) },
    shownRecharges() {
      const start = (this.page - 1) * 8
      return this.recharges.slice(start, start + 8)
    },
    rebateText() {
      const rate = this.desk.rebateRate
      if (rate === null || rate === undefined || rate === '') return '未配置'
      return (Number(rate) * 100).toFixed(2).replace(/\.00$/, '') + '%'
    },
    link() {
      return this.desk.promoUrl || ''
    },
    bank() {
      return this.desk.bank || BANK
    },
    dialogTitle() {
      if (this.channel === 'bank') return '对公转账'
      if (this.channel === 'alipay') return '支付宝'
      return '微信支付'
    },
    payAmount() {
      if (this.paySession && this.paySession.yuanAmount != null) return this.paySession.yuanAmount
      return this.yuan
    }
  },
  created() { this.load() },
  beforeDestroy() { this.stopPoll() },
  methods: {
    async load() {
      this.desk = await getEcoDesk()
      if (this.page > this.pageCount) this.page = this.pageCount
    },
    timeText(value) {
      if (!value) return '—'
      return String(value).replace('T', ' ').slice(0, 19)
    },
    amountOk() {
      const amount = Number(this.yuan)
      if (!this.yuan || !isFinite(amount) || amount < 1) {
        this.$message.warning('最低 1 元')
        return false
      }
      return true
    },
    rechargeStatus(status) {
      if (status === 'CONFIRMED') return '已到账'
      if (status === 'REJECTED') return '已驳回'
      if (status === 'PAYING') return '待支付'
      return '待审核'
    },
    channelText(channel) {
      if (channel === 'wechat') return '微信'
      if (channel === 'alipay') return '支付宝'
      if (channel === 'bank') return '对公转账'
      return '待审核'
    },
    async onProof(event) {
      const file = event.target.files && event.target.files[0]
      if (!file) return
      if (file.size > 10 * 1024 * 1024) {
        this.$message.warning('凭证不能超过 10MB')
        return
      }
      const result = await uploadFile(file, 'eco-proof', { useAdmin: true })
      this.proofUrl = normalizeFileUrl(result.url)
      this.proofName = file.name
    },
    copyBank() {
      const bank = this.bank
      this.copyText([
        '公司名称：' + bank.companyName,
        '统一信用代码：' + bank.creditCode,
        '地址：' + bank.address,
        '开户行：' + bank.bankName,
        '银行账号：' + bank.accountNo
      ].join('\n'), '账户信息已复制')
    },
    copyText(text, success) {
      const done = () => this.$message.success(success)
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(done).catch(() => this.copyByTextarea(text, done))
        return
      }
      this.copyByTextarea(text, done)
    },
    copyByTextarea(text, done) {
      let copied = false
      const onCopy = (event) => {
        event.preventDefault()
        if (event.clipboardData) {
          event.clipboardData.setData('text/plain', text)
          copied = true
        }
      }
      document.addEventListener('copy', onCopy)
      let ok = false
      try {
        ok = document.execCommand('copy')
      } catch (e) {
        ok = false
      }
      document.removeEventListener('copy', onCopy)
      if (ok && copied) {
        done()
        return
      }
      const host = document.querySelector('.el-dialog__body') || document.body
      const input = document.createElement('textarea')
      input.value = text
      input.readOnly = true
      host.appendChild(input)
      input.focus()
      input.select()
      try {
        ok = document.execCommand('copy')
      } catch (e) {
        ok = false
      }
      host.removeChild(input)
      if (ok) done()
      else this.$message.warning('复制失败，请手动选择文字')
    },
    openPay() {
      if (!this.amountOk()) return
      if (this.channel === 'bank') {
        this.payOpen = true
        return
      }
      this.recharge()
    },
    onPayClose() {
      if (this.channel !== 'bank') return
      this.proofUrl = ''
      this.proofName = ''
    },
    async recharge() {
      if (!this.amountOk() || this.submitting) return
      if (this.channel === 'bank' && !this.proofUrl) {
        this.$message.warning('请先上传转账凭证')
        return
      }
      this.submitting = true
      try {
        const result = await createEcoRecharge({
          yuan: this.yuan,
          channel: this.channel,
          proofUrl: this.channel === 'bank' ? this.proofUrl : ''
        })
        this.proofUrl = ''
        this.proofName = ''
        if (this.channel === 'alipay' && result.payUrl) {
          window.location.href = result.payUrl
          return
        }
        if (result.qrContent || result.payUrl) {
          this.paySession = result
          this.qrImage = ''
          if (result.qrContent) {
            this.qrImage = await QRCode.toDataURL(result.qrContent, { width: 220, margin: 1 })
          }
          this.payOpen = true
          this.startPoll(result.id)
        } else {
          this.paySession = null
          this.payOpen = false
          this.yuan = ''
          this.$message.success('已提交，等总部审核到账')
        }
        this.load()
      } finally {
        this.submitting = false
      }
    },
    async continuePay(row) {
      this.channel = row.payChannel || 'wechat'
      this.submitting = true
      try {
        const result = await resumeEcoRecharge(row.id)
        if (row.payChannel === 'alipay' && result.payUrl) {
          window.location.href = result.payUrl
          return
        }
        this.paySession = result
        this.qrImage = ''
        if (result.qrContent) {
          this.qrImage = await QRCode.toDataURL(result.qrContent, { width: 220, margin: 1 })
        }
        this.payOpen = true
        this.startPoll(row.id)
      } finally {
        this.submitting = false
      }
    },
    startPoll(id) {
      this.stopPoll()
      this.pollTimer = setInterval(async () => {
        try {
          const row = await refreshEcoRecharge(id)
          if (row && row.status && row.status !== 'PAYING') {
            this.stopPoll()
            this.payOpen = false
            this.paySession = null
            this.yuan = ''
            if (row.status === 'CONFIRMED') this.$message.success('已到账')
            this.load()
          }
        } catch (e) {
          this.stopPoll()
        }
      }, 3000)
    },
    stopPoll() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer)
        this.pollTimer = null
      }
    },
    async redeem() {
      if (!this.code) return
      const result = await redeemEcoRebate({ code: this.code })
      this.code = ''
      this.$message.success('已兑换 ' + result.points + ' 积分')
      this.load()
    },
    copy() {
      if (!this.link) return
      this.copyText(this.link, '链接已复制')
    }
  }
}
</script>

<style scoped>
.pay-box { color: #1f2a44; font-size: 13px; line-height: 1.6; }
.pay-tip { margin: 0 0 12px; color: #5c6780; }
.bank-line { display: flex; gap: 12px; margin-bottom: 8px; }
.bank-line span { width: 96px; flex: none; color: #5c6780; }
.bank-line b { font-weight: 600; user-select: text; }
.proof { margin-top: 12px; }
.pay-qr { text-align: center; }
.pay-qr img { display: block; margin: 0 auto 8px; }
.pager { display: flex; justify-content: flex-end; align-items: center; gap: 10px; margin-top: 12px; color: #667085; font-size: 13px; }
.pager button { border: 1px solid #d5dced; background: #fff; border-radius: 6px; height: 28px; padding: 0 10px; cursor: pointer; }
.pager button:disabled { color: #b0b8c9; cursor: default; }
</style>
